import { ModalConfig } from '../../../contexts/modalContext';

import DocumentTypeModal from './DocumentTypeModal';
import DeleteDocumentModal from './DeleteDocumentModal';
import QRCodeModal from './QRCodeModal';
import OverrideReasonModal from './OverrideReasonModal';

export const modalConfig: ModalConfig = {
    "documentTypeModal": {
        id: 'documentTypeModal',
        modalComponent: DocumentTypeModal,
    },
    "deleteDocumentModal": {
        id: 'deleteDocumentModal',
        modalComponent: DeleteDocumentModal
    },
    "qrCodeModal": {
        id: 'qrCodeModal',
        modalComponent: QRCodeModal
    },
    "overrideReasonModal": {
        id: 'overrideReasonModal',
        modalComponent: OverrideReasonModal
    }
};
